/**
 * distance — metric distance formatting shared by every surface (Spend Map
 * command 4, the 16485.8 km defect). meters -> "0,4 km": one decimal, comma
 * separator. Returns null when there is no location fix (hide it rather than
 * print a bogus value from a default coordinate). withinNearby() gates the
 * nearby list at 20 km. NEAR_METERS is the locked 250 m proximity threshold.
 *
 * Author: Maré Greyling (Thevertex) <mare.greyling@gmail.com> — https://mare-greyling.com
 */
export const NEAR_METERS = 250;           // proximity nudge threshold (locked decision)
export const NEARBY_MAX_METERS = 20000;   // never show a nearby row beyond this

export function fmtKm(meters) {
  if (meters == null || !isFinite(meters) || meters < 0) return null; // no fix -> hide
  return (meters / 1000).toFixed(1).replace('.', ',') + ' km';
}
export function withinNearby(meters) {
  return meters != null && isFinite(meters) && meters >= 0 && meters <= NEARBY_MAX_METERS;
}
